import type { AxiosResponse } from 'axios';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { type Datum } from '~/api/hau-itde-reach-portal-api';
import { reachApi } from '~/api/hauItdeReachPortalApi';

export const useSparepartStore = defineStore('sparepart', () => {
  //State
  const articleNumber = ref('');
  const pollutants = ref<Datum[]>();

  //Actions
  const setArticleNumber = (_articleNumber: string) => {
    articleNumber.value = _articleNumber;
  };

  const setPollutants = (_pollutants: Datum[]) => {
    if (!_pollutants) {
      pollutants.value = _pollutants
      return
    }
    pollutants.value =  Array.from(
      new Map(
        _pollutants.map(item => [`${item.articleNumberPart}-${item.productName}-${item.substanceName}-${item.cas}`, item])
      ).values()
    );
  };

  const loadPollutants = () => {
    return reachApi
      .v1ReachGet(articleNumber.value)
      .then((res: AxiosResponse<Datum[]>) => {
        setPollutants(res.data);
      })
      .catch((err) => {
        throw err;
      });
  };

  //Getters
  const getReachGuid = computed(() => {
    return pollutants.value?.find((x) => x.reachGuid && x.reachGuid.length > 0)
      ?.reachGuid;
  });

  //Return
  return {
    articleNumber,
    pollutants,
    setArticleNumber,
    loadPollutants,
    getReachGuid
  };
});
